module.exports = __webpack_public_path__ + "static/unsplash-66ea041b8307260700897247b21dfbc9.jpg";